import { render, staticRenderFns } from "./CloseDialogSticky.vue?vue&type=template&id=65124a6f&scoped=true"
import script from "./CloseDialogSticky.vue?vue&type=script&lang=js"
export * from "./CloseDialogSticky.vue?vue&type=script&lang=js"
import style0 from "./CloseDialogSticky.vue?vue&type=style&index=0&id=65124a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65124a6f",
  null
  
)

export default component.exports